import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { getSpaceCategory, updateTemplateSpace } from '../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage } from '../../../../app-general';
import { enumSpaceCategory,appsettings } from '../../../../app-settings';
import {Router} from '@angular/router';

@Component({
  selector: 'app-edit-floorspace',
  templateUrl: './edit-floorspace.component.html',
  styleUrls: ['./edit-floorspace.component.scss']
})
export class EditFloorspaceComponent implements OnInit {

  public spaceeditTempateForm : FormGroup;
  public floorTempateForm : FormGroup;
  selectedTempId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;  
  firstcolumns = 2;  
  rowHeight = "79px";
  checkfloorinfo = false;  
  Templatedetails;
  Tempflag = 0;
  Campusdetails;
  Buildingdetails;
  selectedCampusId;
  selectBuildId;
  selTemp_Id;
  Spacecategory_details;
  selectCategoryId=0;
  CampusId;
  BuildingId;
  FloorId;
  UnitId;
  checkResOffLimits = false;
  tempcheckSpaceCategory = 0;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditFloorspaceComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog) { 
        
    this.selectCategoryId = data.SpaceCategoryId;
    this.CampusId = data.CampusId;
    this.BuildingId = data.BuildId;
    this.FloorId = data.TempFloorId;
    this.UnitId = data.TempUnitId;
    
    if(data.isResidentOffLimit == 1)
      this.checkResOffLimits = true;
    else
      this.checkResOffLimits = false;
      
    if(this.selectCategoryId == enumSpaceCategory.StaffArea || this.selectCategoryId == enumSpaceCategory.ActivityArea || 
      this.selectCategoryId == enumSpaceCategory.DiningArea || this.selectCategoryId == enumSpaceCategory.CommonArea)
    {
      this.tempcheckSpaceCategory = 1;
    }
    
    if (data.Description=="null") { data.Description="";}
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {          
          this.firstcolumns = 1;                            
        } 
        else if (change.mqAlias == 'sm') {          
          this.firstcolumns = 2;               
        }  
        else if (change.mqAlias == 'md') {          
          this.firstcolumns = 2; 
        }               
       else
       {         
         this.firstcolumns = 2;                           
       }
      }
    
    });
  }
  
  

  ngOnInit() {
    
    this.spaceeditTempateForm = new FormGroup({
      floorname:new FormControl(''),
      tempID:new FormControl(''),
      unitID:new FormControl(''),
      unitname: new FormControl('',[Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      category: new FormControl('',[Validators.required]),
      description: new FormControl('',[Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
    }) 
    this.spaceeditTempateForm.get('floorname').disable(); 
    this.getSpaceCategory();
  }
  
getSpaceCategory()
{
  try
  {    
    var spaceitem : getSpaceCategory = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"), 
      categoryId: 0
    }
    this.technologyoverlayService.getSpaceCategory(spaceitem).pipe(takeUntil(this._onDestroy))
    .subscribe((spacedetails: any[]) => {
      this.Spacecategory_details = spacedetails;                           
    });
  }
  catch(err) 
  {
    throw new Error('edit-floorspace.component.ts' + ' - getSpaceCategory() - ' + err.message);
  }
}
  
handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.spaceeditTempateForm.controls).forEach(field => { // {1}
        const control = this.spaceeditTempateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('edit-floorspace.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public onCloseCancel = () => {   
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
  
}

selectSpaceCategory(categoryId)
{       
  this.selectCategoryId = categoryId;     
}



public updateTemplateSpaceInfo = (spaceFormValue) => 
{
  try
    {
      var resofflimits = 0;
      
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur();
      
      let _Description = "";        
      if(spaceFormValue.description != "")
        _Description = spaceFormValue.description.replace(/\s+/g, ' ').trim();
      else
        _Description = "";
        
        if(this.checkResOffLimits == true)
          resofflimits = 1;
        else
          resofflimits = 0;
                  
      if (this.spaceeditTempateForm.valid) {         
        let saveclick = document.getElementById('btnfloorspacesaveclick');
            saveclick.className = 'clsfloorspacesavebutton mat-raised-button disablebtn';             
          let updateTemplateSpaceInfo: updateTemplateSpace = {
            siteId:this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            templateId:parseInt(spaceFormValue.tempID),  
            spaceId:parseInt(spaceFormValue.unitID),
            spaceName:spaceFormValue.unitname.replace(/\s+/g, ' ').trim(),     
            spaceDescription:_Description,//spaceFormValue.description.replace(/\s+/g, ' ').trim(),
            spaceCategoryId:this.selectCategoryId,
            residentOffLimits:resofflimits          
          }
            
            this.technologyoverlayService.updateTemplateSpaceInfo(updateTemplateSpaceInfo).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : any[])=>{                             
            if(apiresponse.toString() == "true")
            { 	
              generateAlertMessage(this.dialog, 'Space edited successfully.');                   
              this.thisDialogRef.close();
            }    
            else if(apiresponse.toString() == "false")
            { 
              generateAlertMessage(this.dialog, 'Space edited failed.');	                  
              this.thisDialogRef.close();
            }              
            else if(apiresponse["condition"] == "Authfalse")
            {    
                this.thisDialogRef.close('close');              
                AuthFailedMessage(this.dialog,this.router);  
                return;       
            } 
            else if(apiresponse["condition"] == "spacename")
            {                
              generateAlertMessage(this.dialog, 'Please enter Zone Space Name');                  
              saveclick.className = 'clsfloorspacesavebutton mat-raised-button'; 
              return; 
            }
            else
            { 
              generateAlertMessage(this.dialog, "Zone Space name '" + apiresponse[0].UnitName + "' already exists.");
              saveclick.className = 'clsfloorspacesavebutton mat-raised-button';
            }
          })
       
      }      
    }
    catch(err)
    {
        throw new Error('edit-floorspace.component.ts' + ' - updateTemplateSpaceInfo() - ' + err.message);
    }
}

toggler_ResOffLimits(e) {
  if (e.checked == true) {
    this.checkResOffLimits=true;
  }
  else{
    this.checkResOffLimits=false;
  }
}

}
